import Vue from 'vue'
import Router from 'vue-router'
// 登录
// import HelloWorld from '@/components/HelloWorld'
import Login from '@/views/login/login'
// import LoginSuccess from './views/loginSuccess'
/* 我的工作台 */
import MyWorkbench from '@/views/my-workbench/MyWorkbench'
// 个人中心
import PersonalCenter from '@/views/my-workbench/PersonalCenter'
/* 汇报管理 */
// 提交日报
import SubmitDaily from '@/views/report-manage/daily'
// 提交周报
// 汇报审核
// import ReportingAudit from '@/views/report-manage/ReportingAudit'
// 汇报提交
import ReportSubmitted from '@/views/report-manage/list'
//项目管理
import ProjectManagerPannel from '@/views/project-manage/projectManagerPannel'
// 需求管理
// import DemandManagement from '@/views/project-manage/DemandManagement'
// 需求详情
// import DemandDetails from '@/views/project-manage/DemandDetails'
// 评估工作量
import AssessmentWorkload from '@/views/project-manage/AssessmentWorkload'
// 变更管理
import ChangeManagement from '@/views/change-manage/ChangeManagement'
// 查看关联需求
// import RelatedRequirementsView from '@/views/change-manage/RelatedRequirementsView'
// 关联需求
import RelatedRequirements from '@/views/change-manage/RelatedRequirements'
// 风险管理
// import RiskManagement from '@/views/risk-manage/RiskManagement'
// 会议管理
import MeetingManagement from '@/views/meeting-manage/MeetingManagement'
// 创建会议
import CreatingMeeting from '@/views/meeting-manage/CreatingMeeting'
// 文档管理
// import DocumentManagement from '@/views/document-manage/DocumentManagement'
// 版本管理（版本控制）
// import VersionManagement from '@/views/version-control/VersionManagement'
// 创建版本
import CreatingVersion from '@/views/project-manage/version/list'
// 里程碑
// import Milestone from '@/views/version-control/Milestone'
// 里程碑关联需求
// import MilestoneRelatedRequirementsView from '@/views/version-control/MilestoneRelatedRequirementsView'
// 项目配置
// import ProjectConfiguration from '@/views/project-config/ProjectConfiguration'
// 项目阶段
// import ProjectPhase from '@/views/project-config/ProjectPhase'
// 项目信息
// import ProjectInformation from '@/views/project-config/ProjectInformation'
// 项目联系人管理
import ProjectContact from '@/views/project-manage/projectContact'
// 成员与权限
// import MembersPermissions from '@/views/project-config/MembersPermissions'
// 团队成员
// import TeamMembers from '@/views/project-config/TeamMembers'
// 角色权限
// import RolePermission from '@/views/project-config/RolePermission'
// 任务管理
import TaskManager from '@/views/task-manage/list'
// 统计报表
import StatisticalStatement from '@/views/statistical-statement/StatisticalStatement'
// 公司基本信息
import CompanyInfo from '@/views/system-manage/companyInfo'
// 组织架构管理
// import OrganizationalStructure from '@/views/system-manage/OrganizationalStructure'
// 添加成员
import AddMembers from '@/views/system-manage/AddMembers'
// 数据字典
import dataDictionary from '@/views/system-manage/dict/list'
// 第三方服务账号管理
import OtherServiceAccounts from '@/views/system-manage/OtherServiceAccounts'
// 主界面
import main from '@/views/layout/index'
// 角色权限
import list from '@/views/system-manage/authorize/list'
// 注册公司
// import registered from '@/views/login/registered'
// 首页登录
import index from '@/views/login/index'
// 树形结构
import treetable from '@/views/system-manage/treeTable/DragTreeTable'

import {
  buildTree
} from 'utils/handle'
import routeRes from './mapping'
import {
  compileToFunctions
} from "vue-template-compiler";
// 系统管理员默认权限
const asyncAdminRoutes = [{
    id: 'RDMilestone',
    parentId: 'project-manage-b',
    name: '研发里程碑',
    icon: '',
    path: '/RDMilestone',
    href: 'project-manage/new-start/rd-milestone/RDMilestone',
    status: 1
  },
  {
    id: 'RiskManagement',
    parentId: 'project-manage-b',
    name: '风险管理',
    icon: '',
    href: 'risk-manage/RiskManagement',
    status: 1
  },
  {
    id: 'ChangeManage',
    parentId: 'project-manage-b',
    name: '变更管理',
    icon: 'set',
    href: 'project-manage/change-manage/list',
    status: 1
  },
  {
    id: 'ProjectInformation',
    parentId: 'project-manage-b',
    name: '项目信息',
    icon: 'set',
    path: '/ProjectInformation',
    href: 'project-config/ProjectInformation',
    status: 1
  },
  {
    id: 'DocumentManagement',
    parentId: 'project-manage-b',
    name: '文档管理',
    icon: 'set',
    href: 'document-manage/DocumentManagement',
    status: 1
  },
  {
    id: 'stageSummary',
    parentId: 'project-manage-b',
    name: '阶段总结',
    icon: 'set',
    href: 'stage-manage/stageSummary',
    status: 1
  },
  {
    id: 'ChangeManageList',
    parentId: 'project-manage-b',
    name: '变更管理列表',
    icon: 'set',
    href: 'project-manage/change-manage/check-list',
    status: 1
  },

  {
    id: 'ProgressEstimate',
    parentId: 'project-manage-b',
    name: '进度预估',
    icon: 'set',
    href: 'project-manage/progress-estimate/list',
    status: 1
  },
  {
    id: 'DemandManage',
    parentId: 'project-manage-b',
    name: '需求管理',
    icon: 'set',
    href: 'project-manage/demand-manage/list',
    status: 1
  },
  {
    id: 'DemandDetail',
    parentId: 'project-manage-b',
    name: '需求管理详情',
    icon: 'set',
    href: 'project-manage/demand-manage/demandDetail',
    status: 1
  },

  // {
  //   id: 'my-workspace',
  //   parentId: '0',
  //   name: '我的工作台',
  //   icon: '',
  //   href: 'my-workbench/MyWorkbench',
  //   status: 1,
  //   secondHide: true
  // },
  // {
  //   id: 'record-manage',
  //   parentId: '0',
  //   name: '汇报管理',
  //   icon: '',
  //   href: 'report-manage/list',
  //   status: 1,
  //   secondHide: true
  // },
  // {
  //   id: 'order-manage',
  //   parentId: '0',
  //   name: '任务管理',
  //   icon: '',
  //   href: 'task-manage/list',
  //   status: 1,
  //   secondHide: true
  // },
  // {
  //   id: 'meeting-record',
  //   parentId: '0',
  //   name: '会议记录',
  //   icon: '',
  //   href: 'meeting-manage/MeetingManagement',
  //   status: 1,
  //   //二级目录是否隐藏
  //   secondHide: true
  // },
  // 创建会议
  // {
  //   id: 'CreatingMeeting',
  //   parentId: 'meeting-record',
  //   href: 'meeting-manage/CreatingMeeting',
  //   name: '创建会议',
  //   status: 1
  // },
  // {
  //   id: 'project-manage',
  //   parentId: '0',
  //   name: '项目管理',
  //   icon: 'set',
  //   href: 'project-manage/projectManagerPannel',
  //   status: 1,
  //   secondHide: true
  // },
  // {
  //   id: 'data-ship',
  //   parentId: '0',
  //   name: '数据驾驶舱',
  //   icon: '',
  //   href: 'data-cockpit/DataCockpit',
  //   status: 1
  // },
  {
    id: 'data-ship-a',
    parentId: 'data-ship',
    name: '项目管理驾驶舱',
    icon: '',
    href: 'data-cockpit/DataCockpit',
    status: 1
  },
  {
    id: 'data-ship-b',
    parentId: 'data-ship',
    name: '项目数据看板',
    icon: '',
    href: 'data-cockpit/DataBoard',
    status: 1
  },
  {
    id: 'data-ship-c',
    parentId: 'data-ship',
    name: '资源统计报表',
    icon: '',
    href: 'data-cockpit/ResourceReport',
    status: 1
  },
  {
    id: 'data-ship-d',
    parentId: 'data-ship',
    name: '项目人力资源统计明细',
    icon: '',
    href: 'data-cockpit/StatisticalDetails',
    status: 1
  },

  // {
  //   id: 'orgtree',
  //   parentId: '0',
  //   name: '组织架构管理',
  //   icon: 'role',
  //   href: 'system-manage/organizational-structure/list',
  //   status: 1,
  //   secondHide: true
  // },
  // {
  //   id: 'superadmin',
  //   parentId: '0',
  //   name: '系统设置',
  //   icon: 'set',
  //   href: 'system-manage/companyInfo',
  //   status: 1,
  //   secondHide: true
  // },
  // {
  //   id: 'CompanyInfo',
  //   parentId: 'superadmin',
  //   name: '公司基本信息',
  //   icon: 'account',
  //   href: 'system-manage/companyInfo',
  //   status: 1
  // },
  // {
  //   id: 'superadmin-b',
  //   parentId: 'superadmin',
  //   name: '组织架构管理',
  //   icon: 'role',
  //   href: 'system-manage/organizational-structure/list',
  //   status: 1
  // },
  // {
  //   id: 'superadmin-c',
  //   parentId: 'superadmin',
  //   name: '数据字典管理',
  //   icon: 'authorize',
  //   href: 'system-manage/dict/list',
  //   status: 1
  // },
  // {
  //   id: 'superadmin-cc',
  //   parentId: 'superadmin',
  //   name: '树',
  //   icon: 'authorize',
  //   href: 'system-manage/treeindex',
  //   status: 1
  // },
  // {
  //   id: 'superadmin-d',
  //   parentId: 'superadmin',
  //   name: '第三方服务账号管理',
  //   icon: 'authorize',
  //   href: 'system-manage/OtherServiceAccounts',
  //   status: 1
  // },
  // {
  //   id: 'superadmin-e',
  //   parentId: 'superadmin',
  //   name: '第三方服务账号管理',
  //   icon: 'authorize',
  //   href: 'system-manage/other-service',
  //   status: 1
  // },
  // {
  //   id: 'superadmin-e',
  //   parentId: 'superadmin',
  //   name: '树状结构',
  //   icon: 'authorize',
  //   href: 'system-manage/treeTable/DragTreeTable',
  //   status: 1
  // },
  // {
  //   id: 'superadmin-h',
  //   parentId: 'superadmin',
  //   name: '项目联系人',
  //   icon: 'authorize',
  //   href: 'project-manage/projectContact',
  //   status: 1
  // },

  {
    id: 'project-manage-a',
    parentId: 'project-manage',
    name: '全部项目',
    icon: 'set',
    href: 'project-manage/projectManagerPannel',
    status: 1
  },
  {
    id: 'project-manage-f',
    parentId: 'project-manage',
    name: '需求管理',
    icon: 'set',
    href: 'project-manage/demand-manage/list',
    status: 1
  },

  {
    id: 'project-manage-b',
    parentId: 'project-manage',
    name: '新启动',
    icon: 'set',
    href: 'project-manage/new-start/NewStart',
    status: 1
  },
  // {
  //   id: 'project-manage-c',
  //   parentId: 'project-manage',
  //   name: '进行中',
  //   icon: 'set',
  //   href: '',
  //   status: 1
  // },
  // {
  //   id: 'project-manage-d',
  //   parentId: 'project-manage',
  //   name: '维护中',
  //   icon: 'set',
  //   href: '',
  //   status: 1
  // },
  // {
  //   id: 'project-manage-e',
  //   parentId: 'project-manage',
  //   name: '已结束',
  //   icon: 'set',
  //   href: '',
  //   status: 1
  // },
  // {
  //   id: 'orgtree-b',
  //   parentId: 'orgtree',
  //   name: '公司基本信息',
  //   icon: 'account',
  //   href: 'system-manage/companyInfo',
  //   status: 1
  // },
  // {
  //   id: 'orgtree-a',
  //   parentId: 'orgtree',
  //   name: '组织架构管理',
  //   icon: 'role',
  //   href: 'system-manage/organizational-structure/list',
  //   status: 1
  // },
  // {
  //   id: 'orgtree-e',
  //   parentId: 'orgtree',
  //   name: '功能权限管理',
  //   icon: 'authorize',
  //   href: '',
  //   status: 1
  // },
  // {
  //   id: 'orgtree-c',
  //   parentId: 'orgtree',
  //   name: '数据字典管理',
  //   icon: 'authorize',
  //   href: 'system-manage/dict/list',
  //   status: 1
  // },
  // {
  //   id: 'orgtree-d',
  //   parentId: 'orgtree',
  //   name: '第三方服务账号管理',
  //   icon: 'authorize',
  //   href: 'system-manage/OtherServiceAccounts',
  //   status: 1
  // },
]


Vue.use(Router)

/** 添加路由 */
let routeConfigs = []
routeRes.forEach((item) => {
  routeConfigs.push({
    path: item.path,
    meta: item.meta,
    component: resolve => require(['views/' + item.path + '.vue'], resolve)
  })
})
const whiteList = ['/login', '/test']
let router = new Router({
  base: process.env.BASE_URL,
  routes: [
    // 登录
    {
      path: '/login',
      meta: {
        name: '登录'
      },
      component: resolve => require(['views/login/index'], resolve)
    },
    // 主界面
    {
      path: '/',
      meta: {
        name: '首页'
      },
      component: resolve => require(['views/layout/index'], resolve),
      children: []
    }
  ]
})
/***
 *to :即将要进入的目标路由对象
 *from：当前导航正要离开的路由对象
 *Function: 一定要调用该方法来 resolve 这个钩子。执行效果依赖 next 方法的调用参数。
 */

// console.log("init router before 👇")
// console.dir(router)
router.beforeEach((to, from, next) => {
  if (whiteList.indexOf(to.path) !== -1) {
    // console.log(to)
    // 如果包含数组内则直接跳转
    next()
  } else {
    let getLocalUser = localStorage.getItem('currentUser')

    if (getLocalUser) {
      if (!window.routeMenus) {
        let jsonLocalUser = JSON.parse(getLocalUser)
        let generateIndexRouter = jsonLocalUser.sysPermissionList
        // if (jsonLocalUser.isAdmin) {
        generateIndexRouter = generateIndexRouter.concat(asyncAdminRoutes)
        // }
        // let generateIndexRouter = asyncAdminRoutes; // 模拟数据
        let childRouters = []
        if (generateIndexRouter && generateIndexRouter.length) {
          //获取到了路由目录
          window.routeMenus = buildTree(generateIndexRouter.sort((a, b) => a.sort - b.sort).filter((v) => v.type !== 2))
          //这里需要修改
          //asyncAdminRoutes 一级和二级要作为首页路由的children，但是3级一下路由就不能作为其children
          // console.log('路由', window.routeMenus)
          let buildChildren = function (configRoute, isAppend) {
            let rootChildren = []

            for (let route of configRoute) {
              if (route.children && route.children.length > 0) {
                //存在子路由
                let subChildren = {
                  name: route.id,
                  path: route.id,
                  meta: {
                    name: route.name,
                    keepAlive: true
                  },
                  component: resolve => require(['views/' + route.href + '.vue'], resolve)
                }
                if (isAppend) {
                  rootChildren.push(...buildChildren(route.children, false))
                } else {
                  // 这里是三级路由不需要放到一级路由中去
                  let subsubChildrens = []
                  for (let subsubChildren of route.children) {
                    if (route.href && route.status) {
                      let s = {
                        name: subsubChildren.id,
                        path: subsubChildren.id,
                        meta: {
                          name: subsubChildren.name,
                          keepAlive: true
                        },
                        component: resolve => require(['views/' + subsubChildren.href + '.vue'], resolve)
                      }
                      subsubChildrens.push(s)
                    }
                  }
                  subChildren.children = subsubChildrens
                }
                if (route.href && route.status) {
                  rootChildren.push(subChildren)
                } else {}
              } else {
                if (route.href && route.status) {
                  rootChildren.push({
                    name: route.id,
                    path: route.id,
                    meta: {
                      name: route.name,
                      keepAlive: true
                    },
                    //路由懒加载，避免首次启动，加载时长过长
                    component: resolve => require(['views/' + route.href + '.vue'], resolve)

                  })
                } else {
                  // console.log("不添加",route)
                }
              }
            }
            return rootChildren
          }

          // console.log("要处理的data：", window.routeMenus)
          let ss = buildChildren(window.routeMenus, true);
          // console.log("android小弟写的方法", ss)
          childRouters.push(...ss)

          // for (let route of generateIndexRouter) {
          //   if (route.href && route.status) {
          //     childRouters.push({
          //       path: route.href,
          //       meta: {
          //         name: route.name,
          //         keepAlive: true
          //       },
          //       //路由懒加载，避免首次启动，加载时长过长
          //       component: resolve => require(['views/' + route.href + '.vue'], resolve)
          //     })
          //   }
          // }
        } else {
          window.routeMenus = []
        }
        let allRouters = childRouters.concat(routeConfigs) // asyncResources
        //修改首页的子路由
        router.options.routes[1].children = allRouters
        router.options.routes.push({
          path: '*',
          component: resolve => require(['views/layout/404'], resolve)
        })
        router.addRoutes([...router.options.routes])

        next({
          ...to
        })
      } else {
        next()
      }

    } else {
      window.routeMenus = null
      next({
        path: '/login'
      })
    }
  }
})

export default router

// export default new Router({
//   mode: 'history',
//   base: process.env.BASE_URL,
//   routes: [
//     // 登录
//     {
//       path: '/',
//       name: 'index',
//       component: index
//     },
//     // 登录
//     {
//       path: '/',
//       name: 'Login',
//       component: Login
//     },
//     // 注册公司
//     {
//       path: '/',
//       name: 'registered',
//       component: registered
//     },
//     // 登录后
//     {
//       path: '/loginSuccess',
//       name: 'loginSuccess',
//       component: LoginSuccess
//     },
//     // 角色权限
//     {
//       path: '/',
//       name: 'list',
//       component: list
//     },
//     // 主界面
//     {
//       path: '/main',
//       name: 'main',
//       component: main
//     },
//     // 第三方服务账号管理
//     {
//       path: '/',
//       name: 'OtherServiceAccounts',
//       component: OtherServiceAccounts
//     },
//     // 数据字典
//     {
//       path: '/',
//       name: 'dataDictionary',
//       component: dataDictionary
//     },
//     // 添加成员
//     {
//       path: '/',
//       name: 'AddMembers',
//       component: AddMembers
//     },
//     // 公司基本信息
//     {
//       path: '/',
//       name: 'CompanyInformation',
//       component: CompanyInformation
//     },
//     // 统计报表
//     {
//       path: '/',
//       name: 'StatisticalStatement',
//       component: StatisticalStatement
//     },
//     // 任务管理
//     {
//       path: '/',
//       name: 'TaskManager',
//       component: TaskManager
//     },
//     // 角色权限
//     {
//       path: '/',
//       name: 'RolePermission',
//       component: RolePermission
//     },
//     // 团队成员
//     {
//       path: '/',
//       name: 'TeamMembers',
//       component: TeamMembers
//     },
//     // 成员与权限
//     {
//       path: '/',
//       name: 'MembersPermissions',
//       component: MembersPermissions
//     },
//     // 项目联系人管理
//     {
//       path: '/',
//       name: 'ProjectContact',
//       component: ProjectContact
//     },
//     // 项目配置
//     {
//       path: '/',
//       name: 'ProjectConfiguration',
//       component: ProjectConfiguration
//     },
//     // 项目信息
//     {
//       path: '/',
//       name: 'ProjectInformation',
//       component: ProjectInformation
//     },
//     // 项目阶段
//     {
//       path: '/',
//       name: 'ProjectPhase',
//       component: ProjectPhase
//     },
//     // 里程碑关联需求
//     {
//       path: '/',
//       name: 'MilestoneRelatedRequirementsView',
//       component: MilestoneRelatedRequirementsView
//     },
//     // 里程碑
//     {
//       path: '/',
//       name: 'Milestone',
//       component: Milestone
//     },
//     // 创建版本
//     {
//       path: '/',
//       name: 'CreatingVersion',
//       component: CreatingVersion
//     },
//     // 版本管理
//     {
//       path: '/',
//       name: 'VersionManagement',
//       component: VersionManagement
//     },
//     // 文档管理
//     {
//       path: '/',
//       name: 'DocumentManagement',
//       component: DocumentManagement
//     },
//     // 创建会议
//     {
//       path: '/',
//       name: 'CreatingMeeting',
//       component: CreatingMeeting
//     },
//     // 会议管理
//     {
//       path: '/',
//       name: 'MeetingManagement',
//       component: MeetingManagement
//     },
//     // 风险管理
//     {
//       path: '/',
//       name: 'RiskManagement',
//       component: RiskManagement
//     },
//     // 关联需求
//     {
//       path: '/',
//       name: 'RelatedRequirements',
//       component: RelatedRequirements
//     },
//     // 查看关联需求
//     {
//       path: '/',
//       name: 'RelatedRequirementsView',
//       component: RelatedRequirementsView
//     },
//     // 变更管理
//     {
//       path: '/',
//       name: 'ChangeManagement',
//       component: ChangeManagement
//     },
//     // 评估工作量
//     {
//       path: '/',
//       name: 'AssessmentWorkload',
//       component: AssessmentWorkload
//     },
//     // 需求详情
//     {
//       path: '/',
//       name: 'DemandDetails',
//       component: DemandDetails
//     },
//     // 需求管理
//     {
//       path: '/',
//       name: 'DemandManagement',
//       component: DemandManagement
//     },
//     // 汇报提交
//     {
//       path: '/',
//       name: 'ReportSubmitted',
//       component: ReportSubmitted
//     },
//     // 汇报审核
//     {
//       path: '/',
//       name: 'ReportingAudit',
//       component: ReportingAudit
//     },
//     // 提交周报
//     {
//       path: '/',
//       name: 'SubmitWeeklyReport',
//       component: SubmitWeeklyReport
//     },
//     // 提交日报
//     {
//       path: '/',
//       name: 'SubmitDaily',
//       component: SubmitDaily
//     },
//     // 个人中心
//     {
//       path: '/',
//       name: 'PersonalCenter',
//       component: PersonalCenter
//     },
//     // 我的工作台
//     {
//       path: '/',
//       name: 'MyWorkbench',
//       component: MyWorkbench
//     }
//   ]
// })



// WEBPACK FOOTER //
// ./src/router/index.js